var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client';
import { GetPromptUsagesDocument, ListPromptsDocument } from './Queries.gql';
export function usePrompts() {
    const _a = useQuery(ListPromptsDocument), { data } = _a, rest = __rest(_a, ["data"]);
    return Object.assign({ prompts: (data === null || data === void 0 ? void 0 : data.prompts) || [] }, rest);
}
export function usePromptUsage() {
    const { data } = useQuery(GetPromptUsagesDocument);
    return (data === null || data === void 0 ? void 0 : data.promptUsages) || [];
}
